var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { generateClasses } from "../../utilities/components/styles";
var Styles = function (theme) { return ({
    container: {
        alignItems: 'center',
        color: theme.colors.text,
        display: 'flex',
        flexDirection: 'row',
        ':nth-child(1n) > *': {
            fontSize: '14px !important',
        },
        width: '100%',
        justifyContent: 'space-between',
    },
    content: {
        fontFamily: theme.typo.fonts.regular,
        marginBottom: 0,
        marginTop: 0,
    },
    button: {
        width: 'auto !important',
        padding: '6 !important',
        minWidth: 160,
        height: 50,
    },
    close: {
        position: 'absolute',
        top: 5,
        right: 10,
        width: '20px !important',
        cursor: 'pointer',
    },
    action: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "10px"
    }
}); };
export var HeadroomStyles = function (display, hasCloseButton, style) { return (__assign({ backgroundColor: '#EEE', justifyContent: 'center', padding: 6, paddingLeft: 18, paddingRight: hasCloseButton ? 30 : 18, boxShadow: display ? '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)' : 'none' }, style)); };
export var getStyles = generateClasses(Styles);
